import { render } from "./bundleSlider.vue?vue&type=template&id=0ef3c7da"
import script from "./bundleSlider.vue?vue&type=script&lang=js"
export * from "./bundleSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__